(() => {
  'use strict';
  if (window.hiecomAnalyticsStarted) return;
  window.hiecomAnalyticsStarted = true;

  const measurementId = 'G-JP4CJW82WY';
  const pendingKey = 'hiecom.pending-enquiry.v1';
  const maxAge = 30 * 60 * 1000;
  let analyticsAllowed = false;
  let configured = false;
  let leadSent = false;

  // Keep arbitrary query values and contact details out of page metadata.
  const pageLocation = () => {
    const url = new URL(window.location.href);
    const clean = new URL(url.origin + url.pathname);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'gclid', 'dclid', 'gbraid', 'wbraid'].forEach(key => {
      const value = url.searchParams.get(key);
      if (value && value.length <= 200 && !value.includes('@')) clean.searchParams.set(key, value);
    });
    return clean.href;
  };

  const clearPending = () => {
    try { sessionStorage.removeItem(pendingKey); } catch (_) { /* Storage may be blocked. */ }
  };

  const trackConfirmedEnquiry = () => {
    if (!analyticsAllowed || !configured || leadSent ||
        !document.querySelector('[data-hiecom-enquiry-success]')) return;
    let startedAt;
    try { startedAt = Number(sessionStorage.getItem(pendingKey)); } catch (_) { return; }
    const age = Date.now() - startedAt;
    if (!startedAt || age < 0 || age > maxAge) { clearPending(); return; }
    // Consume the pending submission before dispatch, so refresh/back cannot duplicate it.
    clearPending();
    leadSent = true;
    window.gtag('event', 'generate_lead', {
      send_to: measurementId,
      form_id: 'HiEcomContact',
      lead_source: 'website_enquiry'
    });
  };

  const syncConsent = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    analyticsAllowed = privacy.analyticsProcessingAllowed() === true;
    const marketingAllowed = privacy.marketingAllowed() === true;
    const sharingAllowed = privacy.saleOfDataAllowed() === true;
    window['ga-disable-' + measurementId] = !analyticsAllowed;
    window.gtag('consent', 'update', {
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      ad_storage: marketingAllowed ? 'granted' : 'denied',
      ad_user_data: marketingAllowed && sharingAllowed ? 'granted' : 'denied',
      ad_personalization: 'denied'
    });
    if (!analyticsAllowed) { clearPending(); return; }
    // Basic consent mode: the Google library is not loaded until analytics is allowed.
    if (!configured) {
      configured = true;
      window.gtag('js', new Date());
      window.gtag('config', measurementId, {
        page_location: pageLocation(),
        page_referrer: document.referrer ? document.referrer.split(/[?#]/)[0] : '',
        allow_google_signals: false,
        allow_ad_personalization_signals: false
      });
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
      document.head.appendChild(script);
    }
    trackConfirmedEnquiry();
  };

  const rememberSubmission = form => {
    if (!form || form.id !== 'HiEcomContact' || !form.checkValidity() || !analyticsAllowed) return;
    try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch (_) { /* Fail closed. */ }
  };
  // Shopify's challenge can intercept submit and resume via form.submit().
  // Remember a valid attempt before that interception, but count only server-confirmed success.
  document.addEventListener('submit', event => rememberSubmission(event.target), true);
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('click', event => {
    const submit = event.target.closest('#HiEcomContact button[type="submit"]');
    if (submit) rememberSubmission(submit.form);
    if (!event.target.closest('[data-hiecom-cookie-preferences]')) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  }, true);
  document.addEventListener('DOMContentLoaded', trackConfirmedEnquiry);
  window.addEventListener('pageshow', syncConsent);

  let attempts = 0;
  const loadPrivacy = () => {
    if (window.Shopify && window.Shopify.customerPrivacy) { syncConsent(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) syncConsent();
      });
    } else if (++attempts < 40) {
      window.setTimeout(loadPrivacy, 250);
    }
  };
  loadPrivacy();
})();
